import { SyncImagesDocument } from '@/lib/graphql/generated/graphql';
import { useMutation } from '@apollo/client/react';

export const useSyncImages = (dealId: string) => {
  const [syncImagesMutation, { loading, error }] =
    useMutation(SyncImagesDocument);

  const syncImages = async (dealItemsIds: string[]) => {
    return syncImagesMutation({
      variables: { dealId, dealItemsIds },
    });
  };

  return {
    syncImages,
    loading,
    error,
  };
};
